module.exports = __webpack_public_path__ + "static/media/first.2d11b2f1.jpg";